import classNames from "classnames";
import styles from "./index.module.scss";
// import MainTitle from "@/components/MainTitle";

import "./index.scss";

// import { useEffect, useState, useMemo } from "react";
import { useEffect, useState } from "react";
import intl from "react-intl-universal";
import { overview } from "@/apis/discover";
import CountUp from "./CountUp";
// import 'slick-carousel/slick/slick.css';
// import 'slick-carousel/slick/slick-theme.css';

const Introduction = () => {
  const [list, setList] = useState([
    {
      name: "Header.Open Data",
      value: 0,
      code: "OpenData",
      unit: "条",
      animate: "animate__fadeInTopLeft",
    },
    {
      name: "Header.Open Tools",
      value: 0,
      code: "OpenTools",
      unit: "条",
      animate: "animate__fadeInTopRight",
    },
    {
      name: "Header.Open Docs",
      value: 0,
      code: "OpenDocs",
      unit: "条",
      animate: "animate__fadeInBottomLeft",
    },
    {
      name: "Header.Open Apps",
      value: 0,
      code: "OpenApps",
      unit: "项",
      animate: "animate__fadeInBottomRight",
    },
  ]);
  useEffect(() => {
    const overviewData = () => {
      overview().then((res) => {
        setList(
          list.map((item) => ({
            ...item,
            value: res.data[item.code],
          }))
        );
      });
    };
    overviewData();
  }, []);
  // const lang = useMemo(() => {
  //     return localStorage.getItem("lang") || "en-US"
  // }, []);
  return (
    <div className={classNames("container", styles.introductionBox)}>
      <h1 className={styles.desBox}>
        {intl.get("Header.Community Resources")}
      </h1>
      <div
        className={classNames(
          "flex_box  flex_between align_center",
          styles.totalBox
        )}
      >
        {list.map((item, index) => {
          return (
            <div
              key={item.code}
              className={classNames("wow", item.animate)}
              data-wow-duration="1s"
            >
              <div className="flex_box align_center flex_center flex_direction">
                <span>
                  <CountUp
                    from={0}
                    to={item.value}
                    separator=","
                    direction="up"
                    duration={1}
                  ></CountUp>
                  <span style={{ fontSize: "16px" }}></span>
                </span>
                <i>{intl.get(item.name)}</i>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
export default Introduction;
